module.exports = __webpack_public_path__ + "static/media/talkitoutLogo.f0c7a39e.png";